module.exports = __webpack_public_path__ + "static/media/logoorange.9caf7c9d.png";